routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.mainMenu', {
      url: "panel-de-control/main-menu",
      template: `<main-menu sh-ctrl="shCtrl"></main-menu>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/main-menu/main-menu.config.js